/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

/**
 * Available AWS services
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let Service = exports.Service = function () {
  function Service() {
    _classCallCheck(this, Service);
  }

  _createClass(Service, null, [{
    key: 'identifier',


    /**
     * @param {String} service
     * @returns {String}
     */
    value: function identifier(service) {
      return `${service}.amazonaws.com`;
    }

    /**
     * @param {String} name
     * @returns {Boolean}
     */

  }, {
    key: 'exists',
    value: function exists(name) {
      return -1 !== Service.list().indexOf(name);
    }

    /**
     * @returns {String[]}
     */

  }, {
    key: 'list',
    value: function list() {
      return [Service.ANY, Service.LAMBDA, Service.SIMPLE_STORAGE_SERVICE, Service.DYNAMO_DB, Service.SIMPLE_NOTIFICATION_SERVICE, Service.COGNITO_IDENTITY, Service.COGNITO_IDENTITY_PROVIDER, Service.COGNITO_SYNC, Service.ELASTIC_CACHE, Service.IDENTITY_AND_ACCESS_MANAGEMENT, Service.KINESIS, Service.CLOUD_FRONT, Service.SECURITY_TOKEN_SERVICE, Service.CLOUD_WATCH_LOGS, Service.API_GATEWAY, Service.API_GATEWAY_EXECUTE, Service.CLOUD_SEARCH, Service.SIMPLE_QUEUE_SERVICE, Service.CERTIFICATE_MANAGER, Service.EC2, Service.ELASTIC_SEARCH, Service.CLOUD_WATCH_EVENTS, Service.CLOUD_WATCH, Service.SIMPLE_EMAIL_SERVICE, Service.LAMBDA_EDGE, Service.X_RAY];
    }
  }, {
    key: 'ANY',

    /**
     * @returns {String}
     */
    get: function get() {
      return '*';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'EC2',
    get: function get() {
      return 'ec2';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'LAMBDA',
    get: function get() {
      return 'lambda';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'SIMPLE_EMAIL_SERVICE',
    get: function get() {
      return 'ses';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'SIMPLE_STORAGE_SERVICE',
    get: function get() {
      return 's3';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'DYNAMO_DB',
    get: function get() {
      return 'dynamodb';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'SIMPLE_NOTIFICATION_SERVICE',
    get: function get() {
      return 'sns';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'COGNITO_IDENTITY',
    get: function get() {
      return 'cognito-identity';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'COGNITO_IDENTITY_PROVIDER',
    get: function get() {
      return 'cognito-idp';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'COGNITO_SYNC',
    get: function get() {
      return 'cognito-sync';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'ELASTIC_CACHE',
    get: function get() {
      return 'elasticache';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'IDENTITY_AND_ACCESS_MANAGEMENT',
    get: function get() {
      return 'iam';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'KINESIS',
    get: function get() {
      return 'kinesis';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CLOUD_FRONT',
    get: function get() {
      return 'cloudfront';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CLOUD_SEARCH',
    get: function get() {
      return 'cloudsearch';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'SECURITY_TOKEN_SERVICE',
    get: function get() {
      return 'sts';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CLOUD_WATCH',
    get: function get() {
      return 'cloudwatch';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CLOUD_WATCH_LOGS',
    get: function get() {
      return 'logs';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CLOUD_WATCH_EVENTS',
    get: function get() {
      return 'events';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'API_GATEWAY',
    get: function get() {
      return 'apigateway';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'API_GATEWAY_EXECUTE',
    get: function get() {
      return 'execute-api';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'SIMPLE_QUEUE_SERVICE',
    get: function get() {
      return 'sqs';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CERTIFICATE_MANAGER',
    get: function get() {
      return 'acm';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'ELASTIC_SEARCH',
    get: function get() {
      return 'es';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'LAMBDA_EDGE',
    get: function get() {
      return 'edgelambda';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'X_RAY',
    get: function get() {
      return 'xray';
    }
  }]);

  return Service;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Service.js
// module id = 91
// module chunks = 0